const images = [
  {
    original: '/images/nno_2022_girls.jpg',
    thumbnail: '/images/nno_2022_girls.jpg',
    description: "2022 EHT National Night Out"
  },
  {
    original: '/images/nno_2022_board.jpg',
    thumbnail: '/images/nno_2022_board.jpg',	  
    description: "2022 EHT National Night Out"
  },
  {
    original: '/images/10u_allstars_states_062022.jpg',
    thumbnail: '/images/10u_allstars_states_062022.jpg',	  
    description: "2022 10U All-Stars - NJ State Tournament"
  },
  {
    original: '/images/May_Mayhem_2022_14O_Champs.jpg',
    thumbnail: '/images/May_Mayhem_2022_14O_Champs.jpg',	  
    description: "2022 EHT May Mayhem Tourmament - 14 Open Champions"
  },
  {
    original: '/images/May_Mayhem_2022_14C_Champs.jpg',
    thumbnail: '/images/May_Mayhem_2022_14C_Champs.jpg',
    description: "2022 EHT May Mayhem Tournament - 14 C Champions"
  },
];

export default images;
